<template>
  <div :class="['online-status', {
    'online-status--active': status === true,
    'online-status--inactive': status === false,
    }]"></div>
</template>

<script>
  export default {
    name: "OnlineStatus",

    props: {
      status: {
        type: Boolean,
        default: null,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .online-status {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #eee;

    &--active {
      background: #40ffa7;
    }
    &--inactive {
      background: #fb9494;
    }
  }
</style>



// WEBPACK FOOTER //
// OnlineStatus.vue?3ae39f7f